/* src/app/components/processing/platform-activity/active-steps-table/active-steps-table.component.scss */
:host {
  height: 100%;
}
.mat-mdc-header-row > td {
  padding-bottom: 10em;
}
td {
  background: #FFF;
  font-size: 16px;
  color: #000;
  border: 0;
  height: 55px;
}
td.mat-mdc-cell {
  border: none;
}
.mat-mdc-table .mat-mdc-header-cell {
  background: transparent;
  font-size: 16px;
  --text-color-2: #000;
  border-bottom: 2px solid #FFC107;
}
:host-context(.dark-theme) .mat-mdc-table .mat-mdc-header-cell {
  --text-color-2:#c1c1c1;
}
.mat-mdc-row {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
}
tr td:first-child {
  border-left: 2px solid #223F92;
}
:host-context(.dark-theme) th {
  border-bottom: 1px solid #d4a20e;
}
:host-context(.dark-theme) tr td:first-child {
  border-left: 2px solid #345bcc;
}
:host-context(.dark-theme) td {
  background-color: #363636;
}
/*# sourceMappingURL=active-steps-table.component.css.map */
